import { useMutation } from "@tanstack/react-query";

import http from "../../../http";
import { UPLOAD_CASE_DOCUMENT } from "../../URL";
import { IAxisErrorResponse } from "../../../interfaces";

interface IUploadBody {
  filingCode: string;
  file: File;
}

interface IUploadResponse {
  status: string;
  responseObj: {
    fileContainsVirus?: string;
    fileName?: string;
    fileRoot?: string;
    fileUpload?: string;
    filingCode?: string;
    uploadDate?: string;
    userEmail: string;
  };
}

const uploadDocument = async ({ filingCode, file }: IUploadBody) => {
  const formData = new FormData();
  formData.append("docToUpload", file, file.name);

  const response = await http.post(UPLOAD_CASE_DOCUMENT, formData, {
    params: {
      filingCode,
    },
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};

const useUploadDocument = () =>
  useMutation<IUploadResponse, IAxisErrorResponse, IUploadBody>({
    mutationKey: ["upload-document"],
    mutationFn: uploadDocument,
  });

export default useUploadDocument;
